import React, { useState } from "react";

const hasFieldValue = (value) => {
  if (typeof value === "boolean") return value;
  if (Array.isArray(value)) return value.some(hasFieldValue);
  if (value && typeof value === "object") {
    if (typeof value.isValid === "function") return value.isValid();
    return Object.values(value).some(hasFieldValue);
  }
  return value !== undefined && value !== null && value !== "";
};

const callHandlers =
  (...handlers) =>
  (...args) => {
    handlers.forEach((handler) => {
      if (typeof handler === "function") handler(...args);
    });
  };

const FloatingField = ({
  label,
  active,
  children,
  className = "",
  ...controlProps
}) => {
  const [focused, setFocused] = useState(false);
  const isActive =
    focused || hasFieldValue(active !== undefined ? active : controlProps.value);
  const child = React.isValidElement(children)
    ? React.cloneElement(children, {
        ...children.props,
        ...controlProps,
        onBlur: callHandlers(controlProps.onBlur, children.props.onBlur),
        onChange: callHandlers(controlProps.onChange, children.props.onChange),
        onFocus: callHandlers(controlProps.onFocus, children.props.onFocus),
      })
    : children;

  return (
    <div
      className={`floating-field ${isActive ? "floating-field--active" : ""} ${className}`}
      onFocusCapture={() => setFocused(true)}
      onBlurCapture={() => setFocused(false)}
    >
      <span className="floating-field__label">{label}</span>
      {child}
    </div>
  );
};

export default FloatingField;
